import { Constants } from "appConstants";
import { BaseDetailsContent, HeadingDetails, Loading } from "components";
import { Tenant } from "models/tenant/Tenant";
import { TenantFields } from "models/tenant/types";
import { useEffect, useMemo, useState } from "react";

import useStandardToast from "hooks/useStandardToast";
import { Term } from "models/term/Term";
import { useNavigate, useParams } from "react-router-dom";
import { TenantService } from "services";
import { TermService } from "services/term";
import { TermTypeService } from "services/termType";
import "../styles.scss";

export default function TenantDetails() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [tenant, setTenant] = useState<Tenant | undefined>(undefined);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [terms, setTerms] = useState<Term[] | undefined>(undefined);
	const [availableTerms, setAvailableTerms] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [isLoadingTerms, setIsLoadingTerms] = useState<boolean>(false);
	const { showErrorToast } = useStandardToast();

	const tenantService = new TenantService();
	const termService = new TermService();
	const termTypeService = new TermTypeService();

	useEffect(() => {
		setIsLoading(true);
		tenantService
			.getTenantDetails(String(id))
			.then((tenantResponse: Tenant) => {
				setTenant(tenantResponse);
			})
			.catch(() => {
				navigate("/backoffice/tenants");
				showErrorToast(Constants.strings.errors.failedToGetTenantDetails);
			})
			.finally(() => setIsLoading(false));
	}, [id]);

	useEffect(() => {
		setIsLoadingTerms(true);
		termService
			.getLatestList()
			.then((termResponse: any) => {
				setTerms(termResponse);
			})
			.catch(() => {
				showErrorToast(Constants.strings.errors.failedToGetTenantDetails);
			})
			.finally(() => setIsLoadingTerms(false));
	}, [id]);

	useEffect(() => {
		termTypeService.getAvailableTermTypes().then((termTypes) => {
			setAvailableTerms(termTypes.length > 0);
		});
		const tenantFields = {
			value: id
		};
		localStorage.setItem("tenant", JSON.stringify(tenantFields));
	}, []);

	const cleanTenant = useMemo(() => {
		if (!tenant) return {};
		const links: { [key: string]: string } = {
			[TenantFields.URL]: tenant.url || "n/a",
			[TenantFields.HOMOLOGATION]: tenant.homologUrl || "n/a",
			[TenantFields.BACKOFFICE]: tenant.backofficeUrl || "n/a"
		};

		return {
			...tenant,
			links
		};
	}, [tenant]);

	return (
		<div className="tenant-page">
			{!isLoading ? (
				tenant && (
					<>
						<HeadingDetails title={tenant.name} />
						<BaseDetailsContent
							data={cleanTenant}
							sidePanelFields={[
								TenantFields.ID,
								TenantFields.TYPE,
								TenantFields.DESCRIPTION
							]}
							mainPanelFieldNames={{
								[TenantFields.URL]: Constants.strings.fields[TenantFields.URL],
								[TenantFields.HOMOLOGATION]:
									Constants.strings.fields[TenantFields.HOMOLOGATION],
								[TenantFields.BACKOFFICE]:
									Constants.strings.fields[TenantFields.BACKOFFICE],
								links: "Links"
							}}
							mainPanelFields={["links"]}
							terms={terms}
							availableTerms={availableTerms}
							isLoadingTerms={isLoadingTerms}
						/>
					</>
				)
			) : (
				<div className="tenant-list-loading">
					<Loading type="primary" size={75} />
				</div>
			)}
		</div>
	);
}
